export default {
	'en-CA': {
		mobileName: "Prospects Mobile",
		crmName: "Prospects CRM",
		not_found: {
			not_found_title: "Oops!",
			not_found_msg: "The page you're trying to reach does not exist.",
			not_found_btn: "Go back to the home page"
		},
		nav: {
			forAgents: "For Agents",
			forAssociations: "For Associations",
			contact: "Contact Us",
			about: "About Us",
			mobilePortal: "Mobile Portal",
			news: "News",
			footerTitle1: "Solutions",
			footerTitle2: "Resources",
			footerTitle3: "Company",
			careers: "Careers",
			technicalSupport: "Technical Support",
			helpCenter: "Help Center",
			footerCopyright: "CoreLogic® | Prospects Software Inc.",
			footerPrivacy: "Privacy Policy",
			footerTerms: "Terms & Conditions",
			headerLogo:"logo.svg"
		},
		general: {
			metaTitle: "Prospects Software Inc.",
			metaDescription: "@:home.coverSubtitle",
			currentLanguage: "English",
			learnMore: 'Learn More',
			buy: 'Buy',
			login: 'Login',
			selectMarket: "Select your Market",
			features: "Features",
			basic: "Basic",
			pro: "Pro",
			pleaseSelect: "Please Select",
			appStoreLink: "https://itunes.apple.com/ca/app/prospects/id422759714",
			appStoreImage: "assets/badge-apple-en.svg",
			googleStoreLink: "https://play.google.com/store/apps/details?id=com.prospects_mobile",
			googleStoreImage: "assets/badge-google-en.svg",
			crmBuyLink: "https://qc.prospects.com/prospects/paiement/newuser.do?locale=en",
			crmLoginLink: "https://ca.prospects.com/prospects/logon.do?locale=en",
			mobilePortalLoginLink: "https://ca.prospects.com/prospects/mlstouch/logon.do?loc=en",
			testimonialsTitle: "What people are saying about Prospects",
			maximizeSoftwareTitle: "Learning Resources",
			maximizeSoftwareSubtitle: "Maximize the power of Prospects Mobile. We have videos, webinars, and guides to help you. ",
			watchVideo: "Watch Video"
		},
		home: {
			homeCrm: {
				image: "crm_EN_CA.png"
			},
			homeMobile: {
				image: "mobile_EN_CA.png"
			},
			coverTitle: "The Hub of<br/>Your Business",
			coverSubtitle: "The perfect ecosystem that will allow you to organize your business, reach your goals and save time.",
			corelogicIntegrationSummary1: "A complete ecosystem.",
			corelogicIntegrationSummary2: "Fully integrated with Matrix™ and Realist®",
			crmSummary: "Manage your contacts and your everyday business like never before with the best CRM ever created for real estate professionals.",
			mobileSummary: "The industry's most powerful mobile app provides real time access to your board’s MLS® System and is fully integrated with Matrix and Prospects CRM.",
			integrationsTitle: "<span class='u-weight-bolder'>Integration. </span><span class='u-weight-bold'>Integration. </span>Integration.",
			integrationsText: "If location location location is the mantra in real estate, integration is definitely the buzzword in software. Your contacts and client activity information need to be at your fingertips at all times. Thanks to deep integration links with CoreLogic’s Listing Management Platform (Matrix) and OneHome, your contacts, sent listings, and client favourites are all shared between Matrix, Prospects Mobile and Prospects CRM. ",
			mlsTitle: "Solutions for Associations",
			mlsText: "Very few products can be offered as member benefits to all your members. A powerful CRM and a premium Mobile app all synced with Matrix are staying strong as the top products requested by your members. Provide great tools that will instantly make a difference and help your members increase their business and better organize their work today.",
			jumbotron1: "Prospects is offered",
			jumbotron2: "to more than 950,000 real estate professionals"
		},
		about: {
			coverTitle: "<span class='u-weight-bolder'>Who we are <span class='u-weight-light'>&</span> what we do</span>",
			introducerTitle: "We craft great software tools that keep Agents connected to listings, and engaged with leads and customers.",
			introducerText1: "Prospects Software provides the two most critical tools that real estate professionals rely on every day beyond their primary listing management platform - a premium mobile app and CRM.",
			introducerText2: "MLS-Touch, also known as Prospects Mobile in Canada, keeps Agents connected to listings, leads and contacts from anywhere, on any device.  Prospects CRM gives Agents a powerful tool to organize contacts and manage customer relationships.",
			introducerText3: "Our apps are intelligent, easy-to-use, and fully integrated with each other and with the CoreLogic® Matrix multiple listing platform.",
			introducerTitle2: "We're rapidly expanding into new markets.",
			counterTitle: "Helping real estate agents run their daily business",
			counterIntro: "Our products are in 300 multiple listing markets across North America and we’re expanding every month! With our CRM solution available to more than 275,000 agents and our mobile app is available to 950,000 agents, Prospects is quickly becoming an industry technology leader.",
			firstStatNumber: "300",
			secondStatNumber: "275,000",
			thirdStatNumber: "950,000",
			firstStatDetail: "Markets across North America",
			secondStatDetail: "CRM users",
			thirdStatDetail: "Mobile app users",
			teamTitle: "Meet the team",
			teamIntro: "We're passionate about real estate and technology.  Collectively we have decades of experience working with Real Estate Boards, Brokers, and Agents.  Our mission every day is to help create amazing user experiences for Agents and their clients.",
			ceoTitle: "CEO & Founder",
			mlsTitle: "Account Manager/MLS Liaison",
			trainingTitle: "National Training Manager",
			businessTitle: "Business Development",
			productTitle: "Director of Development and Products",
			marketingTitle: "Director of Marketing & Communications",
			serviceTitle: "Client Success Manager",
			salesTitle: "Director of Sales",
			jobText: "Open Positions",
			jobSubtitle: "Learn more about the exciting positions available at Prospects.",
			careerBtn: "Careers",
		},
		careers: {
			coverTitle: "<span class='u-weight-bolder'>Wanted:</span> talent, passion and motivation",
			mainTitle: "Not a fan of<br>stuffy corporate<br> gigs? <span style='text-decoration: underline; font-style: italic;'>Good!</span>",
			introText1: "At Prospects we're a work family of inspired, driven and humbly confident individuals pushing the boundaries of real estate technology everyday. Our innovative solutions are used by hundreds of thousands of agents across North America to elevate their service and grow their business.",
			introText2: "If you want to accelerate your career, work on projects you're passionate about and be your true self at work - you're exactly what we're looking for.",
			descriptionTitle: "Learning Opportunities,",
			descriptionSubtitle: "flexible hours, free office snacks",
			descriptionText: "Here are some of the top employee perks that Prospects employees say keep them healthy and happy.",
			viewOpenJobs: "View Open Jobs",
			perkTitle1: "Flexible work environment",
			perkDescription1: "Work from home options (beyond Covid) and flexible paid time off, including for professional development.",
			perkTitle2: "RRSP Match",
			perkDescription2: "We invest in your financial health by offering a robust RRSP plan to help you reach your future saving goals.",
			perkTitle3: "Comprehensive Benefits",
			perkDescription3: "Medical, dental, vision care, professional services, employee assistance program, short- and long-term disability insurance, and more.",
			perkTitle4: "Learning",
			perkDescription4: "We support your professional development and lifelong learning. Develop your skills with unlimited access to premium expert-led courses covering technology.",
			contactUs: "To Contact Us",
			listTitle: "Open Jobs",
			uploadLabel: "Upload your C.V.",
			formMessage: "More info",
			formSubmit: "Send",
		},
		support: {
			coverTitle: "Helping You<br/><span class='u-weight-bolder'>With a Smile</span>!",
			introducerTitle: "Support <span class='u-weight-bolder'>Team</span>",
			introducerText1: "Getting started with a new product doesn’t have to be complicated when you have the right team supporting you.",
			introducerText2: "Our customer support team has the resources at their fingertips. You need advice or assistance? We’re here to help. Visit our <a href='https://prospectsinc.zendesk.com/hc' target='_blank' class='link'>@:(nav.helpCenter)</a> or send us an email: <a class='link' href='mailto:support@prospects.com'>support@prospects.com</a>.",
			formTitle: "Let's Get in Touch!",
			formName: "Your Name",
			formEmail: "Your Email",
			formMessage:"Your Message",
			formSubmit: "Send Message",
			salesCustomerService: "Sales & Customer Service",
			technicalSupport: "Technical Support",
			montrealOffice: "Montreal Office",
			openingHours: "9am to 6pm (ET), Monday to Friday",
			addressLine1: "3 Place du Commerce",
			addressLine2: "Suite 400",
			addressLine3: "Montréal, QC, H3E 1H7",
			email: "support@prospects.com",
			phone: "1-888-765-9221",
			phoneHtml: "tel:18887659221",
			success: "Your message was sent successfully. Thanks you!"
		},
		news: {
			coverTitle: "Press, Media Coverage & Blog Posts",
			pageTitle: "Latest News",
			aboutTitle: "About Us",
			aboutText: "Prospects Software creates intelligent, easy-to-use, and fully integrated agent productivity and marketing solutions tools for real estate professionals. MLS-Touch, also known as Prospects Mobile in Canada, keeps agents connected to listings, leads, and contacts from their mobile device. Prospects CRM, designed specifically for real estate, gives agents a powerful tool to prospect for new business and nurture all their leads and customer relationships.",
			socialTitle: "Follow Us",
			contactTitle: "Press Contact",
			contactFunction: "Director of Marketing",
			phoneLabel: "Phone:",
			vidModuleTitle: "Video",
			vidTitle: "Welcome to Prospects, the Hub of an Agent's Business",
			vidLink: "https://www.youtube.com/watch?v=susCuAUpwOU",
			news1: {
				date: "May 2018",
				location: "",
				source: "RIS Media",
				title: "CoreLogic to Offer New CRM and Mobile Solutions to MLS Clients",
				langWarning: "",
				subTitle: "",
				link: "https://rismedia.com/2018/05/10/corelogic-offer-new-crm-mobile-solutions-mls-clients/",
				deck: "",
			},
			news2: {
				date: "May 2018",
				location: "",
				source: "Vendor Alley",
				title: "Prospects Software Chooses CoreLogic as Exclusive Distributor",
				langWarning: "",
				subTitle: "",
				link: "http://www.vendoralley.com/2018/05/21/prospects-plus-inc-chooses-corelogic-exclusive-distributor/",
				deck: "",
			},
			news3: {
				date: "May 2018",
				location: "",
				source: "Inman",
				title: "CoreLogic Gets Exclusive Distribution Deal with Montréal’s Prospects Software",
				langWarning: "",
				subTitle: "",
				link: "https://www.inman.com/2018/05/10/corelogic-gets-exclusive-distribution-deal-with-montreal-propsects-software/?utm_content=buffer47127&utm_medium=social&utm_source=twitter.com&utm_campaign=buffer",
				deck: "",
			},
			news4: {
				date: "May 2018",
				location: "",
				source: "CoreLogic",
				title: "CoreLogic to Offer New CRM and Mobile Solutions to Multiple Listing Clients",
				langWarning: "",
				subTitle: "",
				link: "https://www.corelogic.com/news/corelogic-to-offer-new-crm-and-mobile-solutions-to-multiple-listing-clients.aspx",
				deck: "CoreLogic® (NYSE: CLGX), a leading global property information, analytics and data-enabled solutions provider, today announced an agreement with Prospects Software Inc. to offer their advanced CRM and mobile solutions to its multiple listing clients as powerful new tools that help real estate brokers and agents better manage their leads, clients, past clients and their day-to-day business.",
			},
			news5: {
				date: "August 2018",
				location: "",
				source: "Inman",
				title: "MLS-Touch Now Available to California Regional MLS Members",
				langWarning: "",
				subTitle: "",
				link: "https://www.inman.com/2018/08/02/mls-touch-app-now-available-to-california-regional-mls-members/",
				deck: "If you’re a member of the nation’s largest multiple listing service, you can now download the MLS-Touch app free of cost.  The app, which allows members of multiple listing services across the country to search for property listings on their phones, will become available to approximately 93,500 California Regional MLS (CRMLS) subscribers across the state.",
			},
			news6: {
				date: "May 2019",
				location: "",
				source: "Retechnology",
				title: "Prospects Software Launches Advanced Integrations with Matrix",
				langWarning: "",
				subTitle: "",
				link: "https://retechnology.com/news-list/23854-prospects-software-launches-advanced-integrations-with-matrix",
				deck: "",
			},
			news7: {
				date: "May 2019",
				location: "",
				source: "Wav Group",
				title: "CoreLogic Opens Access to Matrix Client Portal",
				langWarning: "",
				subTitle: "",
				link: "https://www.wavgroup.com/2019/05/20/corelogic-opens-access-to-matrix-client-portal/",
				deck: "In the press release last week, CoreLogic announced that they have opened up the integration to the Matrix Client Portal to Prospects Software. Prospects develops mobile MLS solutions and CRM solutions to enhance agent productivity. The pilot for this integration was in Montréal (CENTRIS). Now it is available in every Matrix Market as a premium service. For the first time, the Matrix Client portal is integrated into a full CRM. The integrations are available in MLS-Touch as well.",
			},
			news8: {
				date: "May 2019",
				location: "Montreal",
				source: "Lisa Gaetz",
				title: "Prospects Software Launches Advanced Integrations with Matrix",
				langWarning: "",
				subTitle: "",
				link: "https://www.prospects.com/en/ca/launch-advanced-integrations",
				deck: "Prospects Software, a member of the CoreLogic® Alliance Network and leading provider of mobile MLS and CRM tools for real estate professionals, announced today the launch of the first in a series of advanced integration features with the CoreLogic Matrix™ multiple listing platform.",
			},
			news9: {
				date: "May 2019",
				location: "",
				source: "COUNCIL OF MLS",
				title: "Prospects Software Launches Advanced CoreLogic Matrix Integrations",
				langWarning: "",
				subTitle: "",
				link: "https://members.councilofmls.org/news/news.asp?id=452704",
				deck: "",
			},
			news10: {
				date: "August 2019",
				location: "Montreal",
				source: "Lisa Gaetz",
				type: "Blog Post",
				title: "5 MLS-Touch - Matrix Integrations That Agents and Their Clients Love",
				langWarning: "",
				subTitle: "",
				deck: "MLS-Touch gives agents the tools they need to stay connected to their MLS, responding to their leads, and engaged with their clients, no matter where they are. Here’s 5 MLS-Touch - Matrix™ integrations that Agents and their clients love.",
			},
			news11: {
				date: "OCTOBER 2019",
				location: "",
				source: "CORELOGIC",
				title: "CoreLogic and Prospects Software Bring New CRM and Mobile Solutions to Las Vegas REALTORS<sup>&reg;</sup>",
				langWarning: "",
				subTitle: "",
				link: "https://www.corelogic.com/news/corelogic-and-prospects-software-bring-new-crm-and-mobile-solutions-to-las-vegas-realtors.aspx",
				deck: "CoreLogic<sup>&reg;</sup> (NYSE: CLGX), a leading global property information, analytics and data-enabled solutions provider, and Prospects Software, a provider of premium agent productivity and marketing solutions, today announced an agreement with the Greater Las Vegas Association of REALTORS<sup>&reg;</sup> (GLVAR) to bring two new solutions to GLVAR members: Prospects CRM and MLS-Touch.",
			},
			news12: {
				date: "OCTOBER 2019",
				location: "Montreal",
				source: "RIS MEDIA",
				title: "CoreLogic and Prospects Software Bring New CRM and Mobile Solutions to Las Vegas REALTORS<sup>&reg;</sup>",
				langWarning: "",
				subTitle: "",
				link: "https://rismedia.com/2019/10/14/corelogic-and-prospects-software-bring-new-crm-and-mobile-solutions-to-las-vegas-realtors/",
				deck: "",
			},
			news13: {
				date: "OCTOBER 2019",
				location: "Montreal",
				source: "VENDOR ALLEY",
				title: "GLVAR to Offer MLS-Touch and Prospect CRM to Membership",
				langWarning: "",
				subTitle: "",
				link: "http://www.vendoralley.com/2019/10/14/glvar-to-offer-mls-touch-and-prospect-crm-to-membership/",
				deck: "",
			},
			news14: {
				date: "OCTOBER 2019",
				location: "Montreal",
				source: "INMAN NEWS",
				title: "Las Vegas MLS to Give Agents New CRM, Mobile App Products",
				langWarning: "",
				subTitle: "",
				link: "https://www.inman.com/2019/10/14/las-vegas-mls-to-give-agents-new-crm-mobile-app-products/",
				deck: "The Greater Las Vegas Association of Realtors will now provide members with Prospects CRM and MLS-Touch.",
			},
			news15: {
				date: "OCTOBER 2019",
				location: "CHINO HILLS, CALIFORNIA",
				source: "CRMLS",
				title: "CRMLS Launches MLS-Touch Realist Integration to 98,000+ Users",
				langWarning: "",
				subTitle: "",
				link: "https://go.crmls.org/crmls-launches-mls-touch-realist-integration-to-98000-users/",
				deck: "CHINO HILLS, CALIFORNIA – California Regional MLS and Prospects Software announced this week a new set of major enhancements that are now available in the MLS-Touch mobile app, a member benefit to CRMLS users. Enhancements include Matrix<sup>™</sup> listing edit capabilities and access to Realist<sup>®</sup> property & tax data from CoreLogic<sup>®</sup>.",
			},
			news16: {
				date: "November 2019",
				location: "Montreal",
				source: "Lisa Gaetz",
				title: "HiCentral MLS Selects MLS-Touch Mobile App for Its 6,500+ Members",
				langWarning: "",
				subTitle: "",
				link: "https://www.prospects.com/en/us/hicentral-selects-mlstouch",
				deck: "Prospects Software, a provider of premium agent productivity and marketing solutions, announced today an agreement with HiCentral MLS to bring its widely adopted MLS-Touch mobile MLS app to Oahu’s 6,500+ agents, as a member benefit.",
			},
			news17: {
				date: "November 2019",
				location: "",
				source: "VENDOR ALLEY",
				title: "HiCentral MLS selects MLS-Touch",
				langWarning: "",
				subTitle: "",
				link: "http://www.vendoralley.com/2019/11/05/hicentral-mls-selects-mls-touch/",
				deck: "",
			},
			news18: {
				date: "November 2019",
				location: "",
				source: "RECOLORADO",
				title: "REcolorado to Provide Brokers with New Premium Mobile App",
				langWarning: "",
				subTitle: "",
				link: "https://www.recolorado.com/news/premiummobileapp.aspx?fbclid=IwAR1GMqTO39Reo5tmytIAbakdh3fe5IqWd84xgCt2VpKzVN9UGiOs-yUpCtA",
				deck: "REcolorado®, Colorado’s largest multiple listing service (MLS) and the provider of the home search site REcolorado.com, today announced an agreement with Prospects Software, a provider of premium agent productivity and marketing solutions, to bring a white-labeled version of its MLS-Touch mobile MLS software to its 25,000+ subscribers as well as millions of Colorado homebuyers and sellers.",
			},
			news19: {
				date: "November 2019",
				location: "",
				source: "VENDOR ALLEY",
				title: "REcolorado to provide white-labeled version of MLS-Touch to members",
				langWarning: "",
				subTitle: "",
				link: "http://www.vendoralley.com/2019/11/22/recolorado-to-provide-white-labeled-version-of-mls-touch-to-members/",
				deck: "",
			},
			news20: {
				date: "February 2020",
				location: "",
				source: "Charles Drouin | Blog Post",
				title: "MLSs - Should You Offer a CRM to Your Members?",
				langWarning: "",
				subTitle: "",
				link: "https://www.prospects.com/en/us/should-themls-offer-crm",
				deck: "The scope of services that should be offered as an MLS member benefit has been an ongoing subject of debate for as long as I can remember. Full disclosure here, I am the founder and CEO of Prospects Software. We’re the team behind the MLS-Touch app (Prospects Mobile in Canada) and Prospects CRM, and we’re a CoreLogic Alliance member. I’ve been working with Associations for a long time and like you, I see many things shifting and changing.",
			},
			news21: {
				date: "April 28, 2020",
				location: "Montréal",
				source: "Lisa Gaetz",
				title: "Heartland MLS Partners with Prospects Software to Deliver Premium Mobile App",
				langWarning: "",
				subTitle: "",
				link: "https://www.prospects.com/en/us/heartland-selects-mlstouch",
				deck: "Prospects Software, a provider of premium agent productivity and marketing solutions, announced today an agreement with Heartland MLS to bring its widely adopted MLS-Touch mobile MLS app to the Kansas City Metro’s 11,000+ agents, as a subscriber benefit.",
			},
			news22: {
				date: "July 2021",
				location: "Montréal",
				source: "Stellar MLS",
				title: "Stellar MLS Adds MLS-Touch and Prospects CRM to Customer Benefits",
				langWarning: "",
				subTitle: "",
				link: "https://www.stellarmls.com/stellar-mls-adds-mls-touch-and-prospects-crm-to-customer-benefits",
				deck: "Stellar MLS, Florida’s largest multiple listing service (MLS), today announced its partnership with Prospects Software, a provider of premium agent productivity and marketing solutions, to bring its Prospects CRM platform and MLS-Touch mobile app to Stellar MLS’ nearly 70,000 customers as a subscriber benefit.",
			},
			news23: {
				date: "August 2021",
				location: "Montréal",
				source: "Wav Group",
				title: "Stellar MLS and Prospects partnered to deliver new customer tools that expand client connections",
				langWarning: "",
				subTitle: "",
				link: "https://www.wavgroup.com/2021/08/03/stellar-mls-and-prospects-partnered-to-deliver-new-customer-tools-that-expand-client-connections/",
				deck: "Stellar MLS now offers its customers both a mobile app and CRM that are fully connected to the MLS. Stellar and Prospects partnered to bring one of the largest MLSs in the nation customer tools that successfully enable client connection from the office or mobile phone. But, it’s not only about the tools, it is about the connection. Stellar MLS and Prospects, the software company, have together elevated the MLS experience in Florida with tools and connection.",
			},
			news24: {
				date: "Jan 2022",
				location: "Montréal",
				source: "Inman",
				title: "CoreLogic acquires Prospects Software following long partnership",
				langWarning: "",
				subTitle: "",
				link: "https://www.inman.com/2022/01/18/corelogic-acquires-prospects-software-following-long-partnership/",
				deck: "Six months after being purchased itself, real estate data and analytics giant CoreLogic announced it has acquired real estate tech firm Prospects Software. The deal closed on January 14. “Prospects is complementary to our Real Estate Solutions business,” CoreLogic Managing Director Devi Mateti said in a statement. “Prospects’ software tools are already integrated with CoreLogic’s market-leading products including our Property Insights Platform (Realist),” he added. “This acquisition is a natural next step as we develop industry-leading capabilities that streamline workflow for real estate professionals and further our mission to help people find, buy and protect the homes they love.”",
			},
			news25: {
				date: "Jan 2022",
				location: "Irvine",
				source: "CoreLogic",
				title: "CoreLogic Acquires Prospects Software to Deliver Advanced Customer Engagement Tools for Real Estate Professionals",
				langWarning: "",
				subTitle: "",
				link: "https://www.corelogic.com/press-releases/corelogic-acquires-prospects-software-to-deliver-advanced-customer-engagement-tools-for-real-estate-professionals/",
				deck: "CoreLogic, a leading global property information, analytics and data-enabled solutions provider, today announced it has acquired Prospects Software, a leading provider of mobile MLS and CRM tools for real estate professionals. Prospect's software integrates seamlessly with the CoreLogic Matrix™ multiple listing platform and provides added value to real estate professionals."
			},
			news26: {
				date: "Sep 2022",
				location: "",
				source: "WavGroup",
				title: "CoreLogic MLS-Touch Mobile App Filling In as Homesnap Replacement",
				langWarning: "",
				subTitle: "",
				link: "https://www.wavgroup.com/2022/09/26/corelogic-mls-touch-mobile-app-filling-in-as-homesnap-replacement/",
				deck: "When CoreLogic acquired Montreal-based Prospects® Software, their product MLS-Touch® was ordained to replace CoreLogic’s GoMLS mobile app. In a press release today, Minneapolis-based NorthstarMLS, St. Louis-based MARIS MLS, and Jacksonville-based realMLS have entered into agreements to launch MLS-Touch as their mobile multiple listing application. This brings the user count on MLS-Touch over the 950,000 mark; making it the most adopted MLS mobile app in real estate."
			},
		},
		privacy: {
			coverTitle: "Privacy Policy",
			headerText: "This Privacy Policy is applicable to the use of Prospect Software Inc.’s Products and to use of our Website",
		},
		terms: {
			coverTitle: "Terms and conditions",
			comingSoon: "Coming soon",
		},
		footer: {
			footerLogo:"logo-white.svg"
		},
	},
	'en-US': {
		mobileName: "MLS-Touch",
		nav: {
			helpCenter: "Help Center"
		},
		general: {
			appStoreLink: "https://itunes.apple.com/us/app/mls-touch/id429788428",
			googleStoreLink: "https://play.google.com/store/apps/details?id=com.mls_touch",
			crmBuyLink: "https://us.prospects.com/prospects/paiement/newuser.do?locale=en",
			crmLoginLink: "https://us.prospects.com/prospects/logon.do?locale=en",
			mobilePortalLoginLink: "https://us.prospects.com/prospects/mlstouch/logon.do?loc=en",
		},
		home: {
			homeMobile: {
				image: "mobile_EN_US.png"
			},
			mobileSummary: "The industry's most powerful mobile app provides real time access to the MLS® and is fully integrated with Matrix and Prospects CRM.",
			integrationsText: "If location location location is the mantra in real estate, integration is definitely the buzzword in software. Your contacts and client activity information need to be at your fingertips at all times. Thanks to deep integration links with CoreLogic’s Listing Management Platform (Matrix) and OneHome, your contacts, sent listings, and client favorites are all shared between Matrix, MLS-Touch and Prospects CRM. ",
			mlsText: "Very few products can be offered as member benefits to all your members. A powerful CRM and a premium Mobile MLS app all synced with Matrix are staying strong as the top products requested by your members. Provide great tools that will instantly make a difference and help your members increase their business and better organize their work today.",

		},
		about: {
			introducerTitle: "We craft great software tools that keep Agents connected to the MLS, and engaged with leads and customers.",
			introducerText1: "Prospects Software provides the two most critical tools that real estate professionals rely on every day beyond their primary MLS - mobile MLS and CRM.",
			counterIntro: "Our products are in 300 MLS markets across North America and we’re expanding every month! With our CRM solution available to more than 275,000 agents and our mobile MLS service available to 950,000 agents, Prospects is quickly becoming an industry technology leader.",
		},
		support: {
			introducerText2: "Our customer support team has the resources at their fingertips. You need advice or assistance? We’re here to help. Visit our <a href='https://prospectsinc.zendesk.com/hc' target='_blank' class='link'>@:(nav.helpCenter)</a> or send us an email: <a class='link' href='mailto:support@prospects.com'>support@prospects.com</a>.",
			phone: "1-888-765-9223",
			phoneHtml: "tel:18887659223",
		},
		news: {
			aboutText: "Prospects Software creates intelligent, easy-to-use, and fully integrated Mobile MLS and CRM tools for real estate professionals. MLS-Touch, also known as Prospects Mobile in Canada, keeps agents connected to listings, leads, and contacts from their mobile device. Prospects CRM, designed specifically for real estate, gives agents a powerful tool to prospect for new business and nurture all their leads and customer relationships.",
			vidLink: "https://www.youtube.com/watch?v=J5C2jfHbS_4&t=29s&frags=pl%2Cwn",
		}
	},
	'fr-CA': {
		mobileName: "Prospects Mobile",
		not_found: {
            not_found_title: "Oups!",
            not_found_msg: "La page que vous recherchez semble introuvable",
            not_found_btn: "Retour à l'accueil"
        },
		nav: {
			forAgents: "Nos solutions",
			forAssociations: "Associations",
			contact: "Nous contacter",
			about: "À propos",
			mobilePortal: "Portail mobile",
			news: "Nouvelles",
			footerTitle1: "Solutions",
			footerTitle2: "Ressources",
			footerTitle3: "Compagnie",
			careers: "Carrières",
			technicalSupport: "Soutien technique",
			helpCenter: "Centre d'aide",
			footerCopyright: "CoreLogic® | Logiciels Prospects Inc.",
			footerPrivacy: "Politique de confidentialité",
			footerTerms: "Termes et conditions",
		},
		general: {
			metaTitle: "Logiciels Prospects Inc.",
			metaDescription: "@:home.coverSubtitle",
			currentLanguage: "Français",
			learnMore: 'En savoir plus',
			buy: 'Acheter',
			login: 'Connexion',
			selectMarket: "Sélectionnez votre marché",
			features: "Fonctionnalités",
			basic: "Base",
			pro: "Pro",
			pleaseSelect: "Veuillez choisir",
			appStoreLink: "https://itunes.apple.com/ca/app/prospects/id422759714",
			appStoreImage: "assets/badge-apple-fr.svg",
			googleStoreLink: "https://play.google.com/store/apps/details?id=com.prospects_mobile",
			googleStoreImage: "assets/badge-google-fr.svg",
			crmBuyLink: "https://qc.prospects.com/prospects/paiement/newuser.do?locale=fr",
			crmLoginLink: "https://qc.prospects.com/prospects/logon.do?locale=fr",
			mobilePortalLoginLink: "https://qc.prospects.com/prospects/mlstouch/logon.do?loc=fr",
			testimonialsTitle: "Ce que l'on dit à propos de Prospects",
			maximizeSoftwareTitle: "Maximisez le potentiel de votre logiciel",
			maximizeSoftwareSubtitle: "Nos formateurs offrent plus de 400 formations gratuites par année sur les différentes fonctionnalités de nos produits et applications.",
			watchVideo: "Visionner vidéo"
		},
		home: {
			coverTitle: "Le centre de<br/>vos affaires",
			coverSubtitle: "L'écosystème parfait qui vous permet d'organiser vos affaires, d'atteindre vos objectifs et de sauver du temps.",
			corelogicIntegrationSummary1: "Un écosystème complet.",
			corelogicIntegrationSummary2: "Intégré avec Matrix™",
			crmSummary: "Gérez vos contacts et votre quotidien comme jamais auparavant avec le meilleur CRM jamais créé pour les professionnels de l'immobilier.",
			mobileSummary: "L'application mobile la plus puissante de l'industrie offre un accès en temps réel aux inscriptions, puis est entièrement intégrée avec Matrix et Prospects CRM.",
			integrationsTitle: "<span class='u-weight-bolder'>Intégration. </span><span class='u-weight-bold'>Intégration. </span>Intégration.",
			integrationsText: "Si l'emplacement est la règle d'or en immobilier, dans le domaine logiciel « intégration » est définitivement le mot à la mode. Les solutions de Prospects sont entièrement intégrées avec vos autres outils Centris afin de vous faciliter la vie! Vos contacts sont partagés entre Matrix, @:mobileName et Prospects CRM.",
			jumbotron1: "Prospects est offert",
			jumbotron2: "à plus de 700 000 professionnels de l'immobilier"
		},
		about: {
			coverTitle: "Nous créons des logiciels,<br/>  <span class='u-weight-bolder'>pour vous</span>.",
			introducerTitle: "Nous concevons des logiciels permettant aux courtiers de rester connectés aux données immobilières et de rester engagés avec leurs clients.",
			introducerText1: "Prospects offre les deux outils les plus critiques sur lesquels les professionnels de l’immobilier comptent tous les jours après leur plate-forme de gestion d’inscriptions: une application de recherche immobilière et un CRM.",
			introducerText2: "Prospects Mobile permet aux courtiers de rester connectés avec leurs inscriptions, leurs prospects et avec leurs contacts n’importe où et sur n'importe quel l’appareil. Prospects CRM est un puissant outil permettant aux courtiers d'organiser leurs contacts ainsi que de gérer leurs relations avec leurs clients.",
			introducerText3: "Nos solutions sont intelligentes, faciles à utiliser et totalement intégrées les unes aux autres, ainsi qu'à la plate-forme CoreLogic® Matrix.",
			counterTitle: "Soutenir les courtiers immobiliers dans leur quotidien",
			counterIntro: "Nos produits sont offerts dans 300 marchés en Amérique du Nord, y compris Centris. Avec notre solution CRM disponible à plus de 275 000 courtiers et notre application mobile disponible à plus de 700 000 courtiers, Prospects devient rapidement un leader technologique de l'industrie immobilière nord-américaine.",
			firstStatDetail: "Marchés en Amérique du Nord",
			secondStatDetail: "Utilisateurs CRM",
			thirdStatDetail: "Utilisateurs mobiles",
			teamTitle: "Rencontrez l'équipe",
			teamIntro: "Nous sommes passionnés par l'immobilier et la technologie. Ensemble, nous avons des décennies d'expérience à travailler pour les chambres immobilières, les agences et les courtiers immobiliers. Notre mission, chaque jour, est de contribuer à créer une expérience utilisateur incroyable pour les courtiers et leurs clients.",
			ceoTitle: "PDG & Fondateur",
			mlsTitle: "Gestionnaire des clients MLS",
			trainingTitle: "Coordinatrice de la formation",
			businessTitle: "Développement des affaires",
			productTitle: "Directeur du développement et des produits",
			marketingTitle: "Directeur marketing et communications",
			salesTitle: "Directeur des ventes",
			serviceTitle: "Gestionnaire du succès client",
			jobText: "À la recherche d'un emploi? Envoyez votre CV à cv@prospects.com!",
			jobSubtitle: "En savoir plus sur les postes disponibles chez Prospects.",
			careerBtn: "Carrières",
		},
		careers: {
			coverTitle: "<span class='u-weight-bolder'>Nous cherchons:</span> talent, passion et motivation",
			mainTitle: "Pas fan des<br>emplois lourds<br>et rigides? <span style='text-decoration: underline; font-style: italic;'>Parfait!</span>",
			introText1: "Prospects c’est une famille de gens inspirées et motivés qui repoussent chaque jour les limites de la technologie immobilière. Nos solutions innovatrices sont utilisées par des centaines de milliers de courtiers en Amérique du Nord cherchant à rehausser la qualité de leurs services et à développer leurs affaires.",
			introText2: "Si vous souhaitez faire avancer votre carrière, travailler sur des projets passionnants et vous sentir vraiment à votre place au travail, vous êtes la personne que nous recherchons. ",
			descriptionTitle: "Apprentissage continuel,",
			descriptionSubtitle: "horaires flexibles, collations gratuites au bureau",
			descriptionText: "Voici parmi les principaux avantages qui, selon nos employés, les gardent heureux et en bonne santé.",
			viewOpenJobs: "Voir postes disponibles",
			perkTitle1: "Environnement de travail flexible",
			perkDescription1: "Options de travail à domicile (même après Covid) et congés payés flexibles, y compris pour le développement professionnel. ",
			perkTitle2: "REER collectif",
			perkDescription2: "Nous investissons dans votre santé financière en offrant un plan REER robuste pour vous aider à atteindre vos objectifs d'épargne futurs.",
			perkTitle3: "Avantages sociaux complets",
			perkDescription3: "Soins médicaux, soins dentaires, soins de la vue, services professionnels, programme d'aide aux employés, assurance invalidité à court et à long terme, et plus encore.",
			perkTitle4: "Formations",
			perkDescription4: "Nous soutenons votre développement professionnel et votre apprentissage tout au long de la vie. Développez vos compétences grâce à un accès illimité à des cours premium dirigés par des experts, couvrant la technologie, les affaires, la création, et plus encore.",
			contactUs: "Pour nous contacter",
			listTitle: "Postes disponibles",
			uploadLabel: "Téléversez votre C.V.",
			formMessage: "Plus d'information",
			formSubmit: "Envoyer",
		},
		support: {
			coverTitle: "Vous aider<br/><span class='u-weight-bolder'>avec un sourire</span>!",
			introducerTitle: "<span class='u-weight-bolder'>Équipe</span> de support",
			introducerText1: "Débuter avec un nouveau produit n'est pas compliqué si vous avez la bonne équipe pour vous soutenir.",
			introducerText2: "Notre équipe de support dispose des ressources nécessaires. Vous avez besoin de conseils ou d'assistance? Nous sommes là pour vous aider. Visitez notre <a href='https://prospectsinc.zendesk.com/hc' target='_blank' class='link'>@:(nav.helpCenter)</a> ou obtenez une réponse par courriel <a class='link' href='mailto:support@prospects.com'>support@prospects.com</a>.",
			formTitle: "Écrivez-nous!",
			formName: "Votre nom",
			formEmail: "Votre courriel",
			formMessage:"Votre message",
			formSubmit: "Envoyer",
			salesCustomerService: "Ventes et service à la clientèle",
			technicalSupport: "Soutien technique",
			montrealOffice: "Bureau de Montréal",
			openingHours: "9h à 18h (HE) du lundi au vendredi",
			addressLine1: "3 Place du Commerce",
			addressLine2: "Suite 400",
			addressLine3: "Montréal, QC, H3E 1H7",
			email: "soutien@prospects.com",
			phone: "1-888-765-9221",
			phoneHtml: "tel:18887659221",
			success: "Votre message a été envoyé avec succès. Merci!"
		},
		news: {
			coverTitle: "Communiqués de presse, médias et blog",
			pageTitle: "Dernières nouvelles",
			aboutTitle: "À propos de nous",
			aboutText: "Les logiciels Prospects conçoit des solutions innovatrices, faciles d'utilisation, une application mobile immobilière et un puissant CRM pour les professionnels de l'immobilier. MLS-Touch, aussi connu sous le nom Prospects Mobile au Canada, permet aux courtiers, à partir de leur appareil mobile, de rester à jour avec leurs inscriptions, leurs prospects et leurs contacts. Prospects CRM est conçu spécifiquement pour l'industrie immobilière et offre aux courtiers de puissants outils de prospection, de marketing et de relation client.",
			socialTitle: "Suivez-nous",
			contactTitle: "Contact média",
			contactFunction: "Directrice au marketing",
			phoneLabel: "téléphone:",
			vidModuleTitle: "Vidéo",
			news1: {
				date: "Mai 2018",
				location: "",
				source: "RIS Media",
				title: "CoreLogic to Offer New CRM and Mobile Solutions to MLS Clients",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "https://rismedia.com/2018/05/10/corelogic-offer-new-crm-mobile-solutions-mls-clients/",
				deck: "",
			},
			news2: {
				date: "Mai 2018",
				location: "",
				source: "Vendor Alley",
				title: "Prospects Software Chooses CoreLogic as Exclusive Distributor",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "http://www.vendoralley.com/2018/05/21/prospects-plus-inc-chooses-corelogic-exclusive-distributor/",
				deck: "",
			},
			news3: {
				date: "Mai 2018",
				location: "",
				source: "Inman",
				title: "CoreLogic Gets Exclusive Distribution Deal with Montréal’s Prospects Software",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "https://www.inman.com/2018/05/10/corelogic-gets-exclusive-distribution-deal-with-montreal-propsects-software/?utm_content=buffer47127&utm_medium=social&utm_source=twitter.com&utm_campaign=buffer",
				deck: "",
			},
			news4: {
				date: "Mai 2018",
				location: "",
				source: "CoreLogic",
				title: "CoreLogic to Offer New CRM and Mobile Solutions to Multiple Listing Clients",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "https://www.corelogic.com/news/corelogic-to-offer-new-crm-and-mobile-solutions-to-multiple-listing-clients.aspx",
				deck: "CoreLogic® (NYSE: CLGX), a leading global property information, analytics and data-enabled solutions provider, today announced an agreement with Prospects Software Inc. to offer their advanced CRM and mobile solutions to its multiple listing clients as powerful new tools that help real estate brokers and agents better manage their leads, clients, past clients and their day-to-day business.",
			},
			news5: {
				date: "Août 2018",
				location: "",
				source: "Inman",
				title: "MLS-Touch Now Available to California Regional MLS Members",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "https://www.inman.com/2018/08/02/mls-touch-app-now-available-to-california-regional-mls-members/",
				deck: "If you’re a member of the nation’s largest multiple listing service, you can now download the MLS-Touch app free of cost.  The app, which allows members of multiple listing services across the country to search for property listings on their phones, will become available to approximately 93,500 California Regional MLS (CRMLS) subscribers across the state.",
			},
			news6: {
				date: "Mai 2019",
				location: "",
				source: "Retechnology",
				title: "Prospects Software Launches Advanced Integrations with Matrix",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "https://retechnology.com/news-list/23854-prospects-software-launches-advanced-integrations-with-matrix",
				deck: "",
			},
			news7: {
				date: "Mai 2019",
				location: "",
				source: "Wav Group",
				title: "CoreLogic Opens Access to Matrix Client Portal",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "https://www.wavgroup.com/2019/05/20/corelogic-opens-access-to-matrix-client-portal/",
				deck: "",
			},
			news8: {
				date: "Mai 2019",
				location: "Montréal",
				source: "Lisa Gaetz",
				title: "Prospects Software Launches Advanced Integrations with Matrix",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "https://www.prospects.com/en/ca/launch-advanced-integrations",
				deck: "Prospects Software, a member of the CoreLogic® Alliance Network and leading provider of mobile MLS and CRM tools for real estate professionals, announced today the launch of the first in a series of advanced integration features with the CoreLogic Matrix™ multiple listing platform.",
			},
			news9: {
				date: "Mai 2019",
				location: "",
				source: "COUNCIL OF MLS",
				title: "Prospects Software Launches Advanced CoreLogic Matrix Integrations",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "https://members.councilofmls.org/news/news.asp?id=452704",
				deck: "",
			},
			news10: {
				date: "Août 2019",
				location: "Montreal",
				source: "Lisa Gaetz",
				type: "Blog Post",
				title: "5 MLS-Touch - Matrix Integrations That Agents and Their Clients Love",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				deck: "MLS-Touch gives agents the tools they need to stay connected to their MLS, responding to their leads, and engaged with their clients, no matter where they are. Here’s 5 MLS-Touch - Matrix™ integrations that Agents and their clients love.",
			},
			news11: {
				date: "Octobre 2019",
				location: "",
				source: "CORELOGIC",
				title: "CoreLogic and Prospects Software Bring New CRM and Mobile Solutions to Las Vegas REALTORS<sup>&reg;</sup>",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "https://www.corelogic.com/news/corelogic-and-prospects-software-bring-new-crm-and-mobile-solutions-to-las-vegas-realtors.aspx",
				deck: "CoreLogic<sup>&reg;</sup> (NYSE: CLGX), a leading global property information, analytics and data-enabled solutions provider, and Prospects Software, a provider of premium agent productivity and marketing solutions, today announced an agreement with the Greater Las Vegas Association of REALTORS<sup>&reg;</sup> (GLVAR) to bring two new solutions to GLVAR members: Prospects CRM and MLS-Touch.",
			},
			news12: {
				date: "Octobre 2019",
				location: "Montreal",
				source: "RIS MEDIA",
				title: "CoreLogic and Prospects Software Bring New CRM and Mobile Solutions to Las Vegas REALTORS<sup>&reg;</sup>",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "https://rismedia.com/2019/10/14/corelogic-and-prospects-software-bring-new-crm-and-mobile-solutions-to-las-vegas-realtors/",
				deck: "",
			},
			news13: {
				date: "Octobre 2019",
				location: "Montreal",
				source: "VENDOR ALLEY",
				title: "GLVAR to Offer MLS-Touch and Prospect CRM to Membership",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "http://www.vendoralley.com/2019/10/14/glvar-to-offer-mls-touch-and-prospect-crm-to-membership/",
				deck: "",
			},
			news14: {
				date: "Octobre 2019",
				location: "Montreal",
				source: "INMAN NEWS",
				title: "Las Vegas MLS to Give Agents New CRM, Mobile App Products",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "https://www.inman.com/2019/10/14/las-vegas-mls-to-give-agents-new-crm-mobile-app-products/",
				deck: "The Greater Las Vegas Association of Realtors will now provide members with Prospects CRM and MLS-Touch.",
			},
			news15: {
				date: "Octobre 2019",
				location: "Montreal",
				source: "CRMLS",
				title: "CRMLS Launches MLS-Touch Realist Integration to 98,000+ Users",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "https://go.crmls.org/crmls-launches-mls-touch-realist-integration-to-98000-users/",
				deck: "CHINO HILLS, CALIFORNIA – California Regional MLS and Prospects Software announced this week a new set of major enhancements that are now available in the MLS-Touch mobile app, a member benefit to CRMLS users. Enhancements include Matrix<sup>™</sup> listing edit capabilities and access to Realist<sup>®</sup> property & tax data from CoreLogic<sup>®</sup>.",
			},
			news16: {
				date: "Novembre 2019",
				location: "Montreal",
				source: "Lisa Gaetz",
				title: "HiCentral MLS Selects MLS-Touch Mobile App for Its 6,500+ Members",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "https://www.prospects.com/en/us/hicentral-selects-mlstouch",
				deck: "Prospects Software, a provider of premium agent productivity and marketing solutions, announced today an agreement with HiCentral MLS to bring its widely adopted MLS-Touch mobile MLS app to Oahu’s 6,500+ agents, as a member benefit.",
			},
			news17: {
				date: "Novembre 2019",
				location: "",
				source: "VENDOR ALLEY",
				title: "HiCentral MLS selects MLS-Touch",
				langWarning: "(article en anglais seulement)",
				subTitle: "",
				link: "http://www.vendoralley.com/2019/11/05/hicentral-mls-selects-mls-touch/",
				deck: "",
			},
			news18: {
				date: "Novembre 2019",
				location: "",
				source: "RECOLORADO",
				title: "REcolorado to Provide Brokers with New Premium Mobile App",
				langWarning: "",
				subTitle: "",
				link: "https://www.recolorado.com/news/premiummobileapp.aspx?fbclid=IwAR1GMqTO39Reo5tmytIAbakdh3fe5IqWd84xgCt2VpKzVN9UGiOs-yUpCtA",
				deck: "REcolorado®, Colorado’s largest multiple listing service (MLS) and the provider of the home search site REcolorado.com, today announced an agreement with Prospects Software, a provider of premium agent productivity and marketing solutions, to bring a white-labeled version of its MLS-Touch mobile MLS software to its 25,000+ subscribers as well as millions of Colorado homebuyers and sellers.",
			},
			news19: {
				date: "Novembre 2019",
				location: "",
				source: "VENDOR ALLEY",
				title: "REcolorado to provide white-labeled version of MLS-Touch to members",
				langWarning: "",
				subTitle: "",
				link: "http://www.vendoralley.com/2019/11/22/recolorado-to-provide-white-labeled-version-of-mls-touch-to-members/",
				deck: "",
			},
			news20: {
				date: "Février 2020",
				location: "",
				source: "Charles Drouin | Blog",
				title: "MLSs - Should You Offer a CRM to Your Members?",
				langWarning: "(anglais seulement)",
				subTitle: "",
				link: "https://www.prospects.com/en/ca/should-themls-offer-crm",
				deck: "",
			},
			news21: {
				date: "April 28, 2020",
				location: "Montréal",
				source: "Lisa Gaetz",
				title: "Heartland MLS Partners with Prospects Software to Deliver Premium Mobile App",
				langWarning: "",
				subTitle: "",
				link: "https://www.prospects.com/en/us/heartland-selects-mlstouch",
				deck: "Prospects Software, a provider of premium agent productivity and marketing solutions, announced today an agreement with Heartland MLS to bring its widely adopted MLS-Touch mobile MLS app to the Kansas City Metro’s 11,000+ agents, as a subscriber benefit.",
			}
		},
		privacy: {
			coverTitle: "Politique de confidentialité",
			headerText: "Cette politique de confidentialité s’applique à l’utilisation des produits de Logiciel Prospect Inc. et à l’utilisation de notre site Internet.",
		},
		terms: {
			coverTitle: "Termes et conditions",
			comingSoon: "À venir",
		}
	}
}